import FramedIcon from '@passkeys/ui/framed-icon';
import Text from '@passkeys/ui/text';

function AllOptionItem() {
  return (
    <div className="flex items-center gap-x-2">
      <FramedIcon name="circles" size={32} shape="squared" forceLight />
      <Text>All</Text>
    </div>
  );
}
export default AllOptionItem;
